module.exports = __webpack_public_path__ + "img/ktb.98235459.png";